import React from "react";
import { buildTerms } from "../data/termsData";

const TermsContent = ({ eventId }) => {
  const sections = buildTerms(eventId);
  return (
    <div data-testid="terms-content" className="space-y-6">
      <p className="text-white/40 text-xs italic">
        Please read these terms carefully. They are provided for your information and may be
        updated; the terms in your official booking confirmation and the cruise line's passenger
        ticket contract also apply.
      </p>
      {sections.map((sec, i) => (
        <div key={i}>
          <h3 className="font-cond font-bold uppercase tracking-wide text-white text-base mb-1.5">
            {sec.heading}
          </h3>
          <p className="text-white/60 text-sm leading-relaxed">{sec.body}</p>
        </div>
      ))}
    </div>
  );
};

export default TermsContent;
